/**
 * Classes in the order a school thinks of them (PS → Terminale, Nursery →
 * Upper Sixth), not alphabetically (which put 3ème before CE1 and SIL last).
 */
const LEVELS = [
  'PS', 'MS', 'GS', 'SIL', 'CP', 'CE1', 'CE2', 'CM1', 'CM2',
  '6ème', '5ème', '4ème', '3ème', '2nde', '1ère', 'Tle', 'Terminale',
  'Nursery', 'Class 1', 'Class 2', 'Class 3', 'Class 4', 'Class 5', 'Class 6',
  'Form 1', 'Form 2', 'Form 3', 'Form 4', 'Form 5', 'Lower Sixth', 'Upper Sixth',
]

function rank(name: string): number {
  const lower = (name || '').toLowerCase()
  let best = -1
  let bestLength = 0
  LEVELS.forEach((level, index) => {
    const l = level.toLowerCase()
    if (lower.startsWith(l) && l.length > bestLength) { best = index; bestLength = l.length }
  })
  return best === -1 ? LEVELS.length : best
}

export function compareClasses(a: string, b: string): number {
  return rank(a) - rank(b) || a.localeCompare(b, 'fr', { numeric: true })
}

export function sortClasses<T>(items: T[], name: (item: T) => string): T[] {
  return [...items].sort((x, y) => compareClasses(name(x), name(y)))
}
